'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function FAQAccordion({
  faqs,
  color = '#E8445A',
}: {
  faqs: { question: string; answer: string }[];
  color?: string;
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {faqs.map((faq, i) => {
        const isOpen = openIndex === i;

        return (
          <div key={`faq-${i}`} className={`faq-item ${isOpen ? 'open' : ''}`}>
            <button
              className="w-full flex items-center justify-between gap-4 p-5 text-left"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              <span
                style={{
                  color: isOpen ? color : 'var(--color-dark)',
                }}
                className="font-heading font-semibold text-[15px] leading-[1.4]"
              >
                {faq.question}
              </span>

              <div
                className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300"
                style={{
                  backgroundColor: isOpen ? `${color}20` : `${color}10`,
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                <Icon
                  name="ChevronDownIcon"
                  size={16}
                  style={{
                    color: isOpen ? color : `${color}80`,
                  }}
                />
              </div>
            </button>

            <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
              <div className="px-5 pb-5">
                <p className="text-brand-mid text-[14.5px] leading-[1.7] font-body">{faq.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
